import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { storeRequestMetadataClient } from 'apps/http/actions/http';

class RoutingMetadata extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    currentRoute: PropTypes.string.isRequired,
  };

  shouldComponentUpdate(nextProps) {
    const { currentRoute } = this.props;
    return currentRoute !== nextProps.currentRoute;
  }

  componentDidUpdate(prevProps) {
    const { dispatch, currentRoute } = this.props;
    const metaData = {
      previousRoute: prevProps.currentRoute,
      currentRoute,
      origin: document.location.origin,
      referrer: `${document.location.origin}${prevProps.location.pathname}${prevProps.location.search}`,
    };

    dispatch(storeRequestMetadataClient(metaData));
  }

  render() {
    return null;
  }
}

export default connect((state, ownProps) => ({
  currentRoute: ownProps.location.pathname + ownProps.location.search.toLowerCase(),
}))(RoutingMetadata);
